<template>
  <div class="row">
    <!-- Active vs Inactive Insights -->
    <div class="col-xl-6 p-3">
      <b-card :title="chartTitle">
        <div class="filter-container d-flex flex-wrap align-items-center gap-2">
          <select v-model="selectedUserIdInsights" @change="fetchData" class="form-control w-auto">
            <option value="">All Users</option>
            <option v-for="user in users" :key="user.id" :value="user.id">
              {{ user.full_name }}
            </option>
          </select>

          <select v-model="selectedFilter" @change="fetchData" class="form-control w-auto">
            <option value="distribution">Insights Type Distribution</option>
            <option value="tasks_over_time">Insights Over Time</option>
          </select>

          <div
            class="d-flex flex-column flex-xl-row align-items-center justify-content-center gap-2 w-100 text-center mt-4">
            <div class="d-flex align-items-center gap-2">
              <label for="start_date">Start Date:</label>
              <input type="date" id="start_date" v-model="start_date" class="form-control w-auto">
            </div>
            <div class="d-flex align-items-center gap-2">
              <label for="end_date">End Date:</label>
              <input type="date" id="end_date" v-model="end_date" class="form-control w-auto">
            </div>
            <b-button variant="primary" class="mt-2 mt-xl-0" @click="fetchData">Apply</b-button>
          </div>
        </div>


        <div v-if="isLoading" class="loader-container-1">
        </div>
        <apexchart v-else :key="selectedFilter" :type="chartType" height="250" :options="chartOptions"
          :series="chartData">
        </apexchart>
      </b-card>
    </div>

    <!-- Azure Storage Graph -->
    <div class="col-xl-6 p-3">
      <b-card title="Azure Storage (MB)">
        <div class="filter-container d-flex flex-wrap align-items-center gap-2">
          <div class="d-flex flex-column flex-xl-row align-items-xl-center gap-2 w-100">
            <div class="d-flex flex-column align-items-center text-center gap-2 w-100">
              <div class="row w-100 justify-content-center align-items-center g-2">
                <div class="col-auto d-flex align-items-center gap-2">
                  <label for="start_date">Start Date:</label>
                  <input type="date" id="start_date" v-model="start_date" class="form-control">
                </div>

                <div class="col-auto d-flex align-items-center gap-2">
                  <label for="end_date">End Date:</label>
                  <input type="date" id="end_date" v-model="end_date" class="form-control">
                </div>

                <div class="col-auto">
                  <b-button variant="primary" @click="fetchazurstorage">Apply</b-button>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div v-if="isLoadingAzurStorage" class="loader-container">
        </div>
        <div v-else>
          <apexchart v-if="graphData3.length > 0" type="bar" height="300" :options="azureChartOptions"
            :series="graphData3"></apexchart>
          <div v-else class="no-data-container">
            <!-- <p>Sorry, data not found.</p> -->
          </div>
        </div>
      </b-card>
    </div>


    <!-- Rakoon Prompt Graph -->
    <div class="col-xl-6 p-3">
      <b-card title="Rakoon Prompt">
        <div class="filter-container mb-3">
          <label for="userFilter" class="col-xl-6 text-left">Select User:</label>
          <select v-model="selectedUserIdRakoon" @change="fetchRakoonPrompt" class="form-control">
            <option value="">All Users</option>
            <option v-for="user in users" :key="user.id" :value="user.id">
              {{ user.full_name }}
            </option>
          </select>
        </div>

        <!-- Wrap in a div to allow proper margin -->
        <div class="mt-4">
          <div class="filter-container d-flex align-items-center gap-2 flex-wrap">
            <div class="d-flex align-items-center gap-2">
              <label for="start_date">Start Date:</label>
              <input type="date" id="start_date" v-model="start_date" class="form-control w-auto">
            </div>
            <div class="d-flex align-items-center gap-2">
              <label for="end_date">End Date:</label>
              <input type="date" id="end_date" v-model="end_date" class="form-control w-auto">
            </div>
            <b-button variant="primary" class="w-auto" @click="fetchRakoonPrompt">Apply</b-button>
          </div>
        </div>

        <div v-if="isLoadingRakoon" class="loader-container"></div>

        <div v-else>
          <apexchart v-if="graphDataRakoon.length > 0" type="line" height="250" :options="rakoonChartOptions"
            :series="graphDataRakoon"></apexchart>
          <div v-else class="no-data-container">
            <!-- <p>Sorry, data not found.</p> -->
          </div>
        </div>
      </b-card>
    </div>

    <!-- System Use Graph -->
    <div class="col-xl-6 p-3">
      <b-card title="System Use">
        <div class="row">
          <!-- LHS: User Select -->
          <div class="col-xl-6">
            <div class="filter-container">
              <label for="userFilter" class="col-xl-6 text-left">Select User:</label>
              <select v-model="selectedUserIdSystemUse" @change="fetchSystemUse" class="form-control">
                <option value="">All Users</option>
                <option v-for="user in users" :key="user.id" :value="user.id">
                  {{ user.full_name }}
                </option>
              </select>
            </div>
          </div>

          <!-- RHS: Type Select -->
          <div class="col-xl-6">
            <div class="filter-container">
              <label for="typeFilter">Select Type:</label>
              <select v-model="selectedTypeSystemUse" @change="fetchSystemUse" class="form-control">
                <option :value="null">All Types</option>
                <option value="created">Created</option>
                <option value="updated">Updated</option>
              </select>
            </div>
          </div>
        </div>

        <div class="filter-container d-flex align-items-center gap-2 flex-wrap">
          <div class="d-flex align-items-center gap-2">
            <label for="start_date">Start Date:</label>
            <input type="date" id="start_date" v-model="start_date" class="form-control w-auto">
          </div>

          <div class="d-flex align-items-center gap-2">
            <label for="end_date">End Date:</label>
            <input type="date" id="end_date" v-model="end_date" class="form-control w-auto">
          </div>

          <b-button variant="primary" class="w-auto" @click="fetchSystemUse">Apply</b-button>
        </div>
        <div v-if="isLoadingSystemUse" class="loader-container">
        </div>
        <div v-else>
          <apexchart v-if="graphDataSystem.length > 0" type="area" height="250" :options="systemUseChartOptions"
            :series="graphDataSystem">
          </apexchart>
          <div v-else class="no-data-container">
            <!-- <p>Sorry, data not found.</p> -->
          </div>
        </div>
      </b-card>
    </div>

  </div>

</template>

<script>
import { ref, onMounted, watch } from 'vue';
import VueApexCharts from "vue-apexcharts";
import { request } from '@/Util/Request';
import moment from 'moment';


export default {
  components: { apexchart: VueApexCharts },
  setup() {
    const selectedFilter = ref('tasks_over_time');
    const selectedUserIdInsights = ref('');
    const selectedUserIdRakoon = ref('');
    const selectedUserIdSystemUse = ref('');
    const users = ref([]);
    const isLoading = ref(false);
    const isLoadingAzurStorage = ref(false);
    const isLoadingRakoon = ref(false);
    const isLoadingSystemUse = ref(false);
    const selectedTypeSystemUse = ref(null);
    const start_date = ref(new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split("T")[0]);
    const end_date = ref(new Date().toISOString().split("T")[0]);
    const chartData = ref([]);
    const chartTitle = ref('');
    const chartType = ref('area');
    const chartOptions = ref({
      chart: { type: 'bar', toolbar: { show: false } },
      xaxis: { categories: [] },
      yaxis: { labels: { formatter: (value) => value.toFixed(2) } },
      colors: ['#008FFB'],
    });




    const graphData3 = ref([]);
    const azureChartOptions = ref({
      chart: { type: 'bar', height: 250, toolbar: { show: false } },
      xaxis: { categories: [] },
      yaxis: { labels: { formatter: (value) => `${value.toFixed(2)} MB` } },
      colors: ['#1879cc']
    });

    const graphDataRakoon = ref([]);
    const rakoonChartOptions = ref({
      chart: { type: "line", toolbar: { show: false } },
      xaxis: { categories: [] },
      yaxis: { labels: { formatter: (value) => value.toFixed(2) } },
      colors: ["#007bff", "#28a745", "#ffc107"], // Initial colors before data is loaded
    });
    const graphDataSystem = ref([]);

    const systemUseChartOptions = ref({
      chart: {
        type: 'line',
        toolbar: { show: false }
      },
      xaxis: {
        categories: [],
        labels: { rotate: -45 }
      },
      yaxis: {
        labels: {
          formatter: (value) => value.toFixed(2)
        }
      },
      stroke: {
        curve: 'smooth',
        width: 3,
        dashArray: [5, 0, 5]
      },
      markers: {
        size: 6,
        shape: "circle",
        strokeWidth: 3,
        hover: { size: 8 }
      },
      colors: ['#1879cc', '#33FF57', '#3357FF'],
      dataLabels: { enabled: false },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          type: 'horizontal',
          gradientToColors: ['#33FF57', '#3357FF'],
          stops: [0, 100]
        }
      },
      tooltip: {
        theme: 'dark',
        x: { format: 'dd MMM yyyy' },
        y: { formatter: (value) => `${value} called` }
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right'
      }
    });



    const fetchUsers = async () => {
      try {
        const response = await request({ method: 'get', url: `/admin/get-users` });
        users.value = response || [];
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    const fetchData = async () => {
      isLoading.value = true;
      try {
        const url = `/admin/system-scheduled-tasks?filter=${selectedFilter.value}&user_id=${selectedUserIdInsights.value || ''}&start_date=${start_date.value}&end_date=${end_date.value}`;

        const response = await request({ method: 'get', url });

        const data = response.scheduled_tasks;

        if (selectedFilter.value === 'distribution') {
          chartOptions.value = {
            ...chartOptions.value,
            xaxis: { categories: data.schedule_type_distribution.type },
            colors: ['#007bff']
          };
          chartData.value = [{ name: 'Count', data: data.schedule_type_distribution.count }];
          chartTitle.value = 'Insights Type Distribution';
          chartType.value = 'bar';
        } else if (selectedFilter.value === 'active_inactive') {
          chartOptions.value = {
            chart: { type: 'donut' },
            labels: ['Active', 'Inactive'],
            colors: ['#28a745', '#007bff'],
            legend: { position: 'left' },
            dataLabels: {
              enabled: true,
              formatter: function (val, opts) {
                const count = opts.w.config.series[opts.seriesIndex];
                return count;
              }
            }
          };
          chartData.value = [data.active_inactive_schedules.count[0], data.active_inactive_schedules.count[1]];
          chartTitle.value = 'Active vs Inactive Insights';
          chartType.value = 'donut';
        } else if (selectedFilter.value === 'tasks_over_time') {
          chartOptions.value = {
            ...chartOptions.value,
            xaxis: { categories: data.scheduled_tasks_over_time.date.map(date => moment(date).format("YYYY-MM-DD")) },
            colors: ['#007bff']
          };
          chartData.value = [{ name: 'Count', data: data.scheduled_tasks_over_time.count }];
          chartTitle.value = 'Insights Over Time';
          chartType.value = 'line';
        }
      } catch (error) {
        console.error('Error fetching chart data:', error);
        chartData.value = [];
      } finally {
        isLoading.value = false;
      }
    };








    const fetchazurstorage = async () => {
      isLoadingAzurStorage.value = true;
      try {
        const response = await request({
          method: 'get',
          url: `/admin/storage-data-over-time`,
          params: {
            start_date: start_date.value,
            end_date: end_date.value,
            include_zeros: false,
            user_id: selectedUserIdInsights.value || ''
          }
        });

        if (response) {
          graphData3.value = [{
            name: "Storage",
            data: response.total_size || []
          }];
          azureChartOptions.value.xaxis.categories = response.date || [];
        }

      } catch (error) {
        console.error("Error fetching Azure Storage:", error);
      } finally {
        isLoadingAzurStorage.value = false;
      }
    };


    const fetchRakoonPrompt = async () => {
      isLoadingRakoon.value = true;
      try {
        const response = await request({
          method: "get",
          url: "/admin/get-rakoon-prompt-data",
          params: {
            start_date: start_date.value,
            end_date: end_date.value,
          },
        });

        if (response) {
          // Set X-axis categories (Dates)
          rakoonChartOptions.value.xaxis.categories = response.date || [];

          // Initialize user-wise data mapping
          const userWiseData = response.user_wise || {};
          const seriesMap = {};

          response.date.forEach((date, index) => {
            if (userWiseData[date]) {
              Object.entries(userWiseData[date]).forEach(([user, count]) => {
                if (!seriesMap[user]) {
                  seriesMap[user] = Array(response.date.length).fill(0);
                }
                seriesMap[user][index] = count;
              });
            }
          });

          // Extract unique users
          const users = Object.keys(seriesMap);

          // Define a color palette (Blue, Green, Yellow, Cyan, Purple)
          const colorPalette = ["#007bff", "#28a745", "#ffc107", "#17a2b8", "#6f42c1"];

          // Assign colors dynamically based on user index
          const userColors = users.reduce((acc, user, index) => {
            acc[user] = colorPalette[index % colorPalette.length]; // Cycle colors if users > colors available
            return acc;
          }, {});

          // Convert seriesMap into ApexCharts data format
          graphDataRakoon.value = users.map((user) => ({
            name: user,
            data: seriesMap[user],
          }));

          // Update Chart Options
          rakoonChartOptions.value = {
            ...rakoonChartOptions.value,
            chart: {
              type: "line",
              toolbar: { show: false },
            },
            stroke: {
              curve: "smooth",
              width: 2,
            },
            markers: {
              size: 4,
              hover: { size: 6 },
            },
            colors: users.map((user) => userColors[user]), // Assign colors dynamically
            legend: { position: "top" },
            dataLabels: { enabled: false },
            xaxis: {
              categories: response.date || [],
              labels: { rotate: -45 },
            },
            tooltip: {
              shared: true,
              intersect: false,
              y: {
                formatter: (value) => value.toFixed(0),
              },
            },
          };
        }
      } catch (error) {
        console.error("Error fetching Rakoon Prompt:", error);
      } finally {
        isLoadingRakoon.value = false;
      }
    };

    const fetchSystemUse = async () => {
      isLoadingSystemUse.value = true;
      try {
        const response = await request({
          method: 'get',
          url: `/admin/user-activity-over-time`,
          params: {
            start_date: start_date.value,
            end_date: end_date.value,
            user_id: selectedUserIdSystemUse.value || '',
            type: selectedTypeSystemUse.value || ''
          }
        });

        if (response) {
          graphDataSystem.value = [{ name: "Use", data: response.count || [] }];
          systemUseChartOptions.value.xaxis.categories = response.date || [];
        }

      } catch (error) {
        console.error("Error fetching System Use:", error);
      } finally {
        isLoadingSystemUse.value = false;
      }
    };

    onMounted(() => {
      const savedPreferences = localStorage.getItem("userGraphPreferences");
      if (savedPreferences) {
        const parsedPreferences = JSON.parse(savedPreferences);
        selectedFilter.value = parsedPreferences.selectedFilter || selectedFilter.value;
        selectedUserIdInsights.value = parsedPreferences.selectedUserIdInsights || selectedUserIdInsights.value;
        selectedUserIdRakoon.value = parsedPreferences.selectedUserIdRakoon || selectedUserIdRakoon.value;
        selectedUserIdSystemUse.value = parsedPreferences.selectedUserIdSystemUse || selectedUserIdSystemUse.value;
        selectedTypeSystemUse.value = parsedPreferences.selectedTypeSystemUse || selectedTypeSystemUse.value;
        start_date.value = parsedPreferences.start_date || start_date.value;
        end_date.value = parsedPreferences.end_date || end_date.value;
      }
      fetchUsers();
      fetchData();
      fetchazurstorage();
      fetchRakoonPrompt();
      fetchSystemUse();
    });
    watch(
      [selectedFilter, selectedUserIdInsights, selectedUserIdRakoon, selectedUserIdSystemUse, selectedTypeSystemUse, start_date, end_date],
      () => {
        const userPreferences = {
          selectedFilter: selectedFilter.value,
          selectedUserIdInsights: selectedUserIdInsights.value,
          selectedUserIdRakoon: selectedUserIdRakoon.value,
          selectedUserIdSystemUse: selectedUserIdSystemUse.value,
          selectedTypeSystemUse: selectedTypeSystemUse.value,
          start_date: start_date.value,
          end_date: end_date.value
        };
        localStorage.setItem("userGraphPreferences", JSON.stringify(userPreferences));
      },
      { deep: true }
    );

    return {
      selectedFilter, users,
      chartData, chartTitle, chartType, chartOptions,
      fetchData, fetchazurstorage, fetchRakoonPrompt, fetchSystemUse,
      isLoading, isLoadingAzurStorage, isLoadingRakoon, isLoadingSystemUse,
      start_date, end_date,
      graphData3, azureChartOptions, graphDataRakoon, rakoonChartOptions,
      graphDataSystem, systemUseChartOptions,
      selectedUserIdInsights, selectedUserIdRakoon, selectedUserIdSystemUse, selectedTypeSystemUse,

    };
  }

};
</script>

<style scoped>
.no-data-container {
  text-align: center;
  height: 275px;
  font-size: 16px;
  font-weight: bold;
  color: #6c757d;
}

.graph-container {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  min-height: 500px;
  /* Adjust this value as needed */
  display: flex;
  flex-direction: column;
  justify-content: center;
}


.user-filter-container {
  background: #f8f9fa;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}

b-card {
  min-height: 250px;
}

.filter-container {
  background: #ffffff;
  padding: 10px;
  border-radius: 8px;
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}

.user-filter-container label,
.filter-container label {
  font-weight: bold;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
}

.loader-container-1 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 280px;
}
</style>
